var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('LeftNav'),_c('main',{attrs:{"id":"page-wrap"}},[_c('vue-snotify'),_c('b-container',{attrs:{"fluid":""}},[_c('BranchInfoWidget')],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }